import { useContext, useEffect, useState } from "react";
import { fetchSocials } from "../../../../services/Candidate/Profile/fetchCandidateDetails";
import { DContext } from "../../../../../context/Datacontext";
import { FiEdit2 } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";

function SocialProfiles({ candidate, setViewData, setPopupTitle, currentUser }) {

    const { BeURL, showAlert } = useContext(DContext)
    const navigate = useNavigate()
    const location = useLocation()

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(3);
    const [totalItems, setTotalItems] = useState(0)
    const [totalPage, setTotalPage] = useState(0);
    const [profiles, setProfiles] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (BeURL && currentPage && itemsPerPage) {
            setLoading(true)
            fetchSocials(BeURL, candidate._id, currentPage, itemsPerPage, setTotalItems, setTotalPage, setProfiles, showAlert, setLoading)
        }
    }, [currentPage, itemsPerPage, BeURL])

    useEffect(() => {
        setCurrentPage(1)
    }, [itemsPerPage])

    const handlePopupView = (p) => {
        const viewData = {
            Name: p.socialName || "",
            Url: p.url || "",
            Description: p.description || ""
        }

        setPopupTitle("Social Profile")
        setViewData(viewData)
    }

    if (loading) {
        return <div className="my-3 bg-white p-2 rounded-xl">Loading...</div>
    }

    return (
        <div className="my-3 bg-white p-2 rounded-xl w-full lg:w-[49%]">
            {/* */}
            <div className="flex justify-between items-end"><h3 className="font-semibold text-lg  mt-4">Social Profiles</h3>
           <FiEdit2 className="text-primary-500 text-xl font-bold" onClick={() => navigate(`/update-account/highlights?inverse=${true}&candidateId=${candidate._id}`, { state: { from: location.pathname, active: 'Highlights' } })} /></div>
            <div className="my-2 min-h-[20vh] overflow-x-auto">
                <table className="border-separate border-spacing-y-1 w-full table-fixed">
                    <thead>
                        <tr className="text-left mb-2 rounded-lg">
                            <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300 rounded-l-lg  truncate whitespace-nowrap overflow-hidden">Name</th>
                            <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300 hidden md:table-cell truncate whitespace-nowrap overflow-hidden">Url</th>
                            <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300 rounded-r-lg">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            profiles?.length > 0 ?
                                profiles.map((p, i) => (
                                    <tr className="rounded-lg" key={i}>
                                        <td className="text-sm px-2 py-1 bg-white rounded-l-lg">{p.socialName}</td>
                                        <td className="text-sm px-2 py-1 bg-white hidden md:table-cell">{p.url || "-"}</td>
                                        <td className="text-sm px-2 py-1 bg-white rounded-r-lg">
                                            <div className="flex items-center">
                                                <span className="bg-purple-50 text-secondary-300 px-3 py-1 text-sm rounded-lg cursor-pointer" onClick={() => handlePopupView(p)}>View</span>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                :
                                (<tr
                                    className="text-center text-sm "
                                >
                                    <td colSpan={4} className="text-center p-2">No Data Available!</td>
                                </tr>)
                        }

                    </tbody>
                </table>
            </div>

            <div className="flex flex-row items-center justify-between gap-5">
                <div className="flex items-center justify-center gap-2 flex-1">
                    <label className="text-xs">Page</label>
                    <select value={itemsPerPage} onChange={e => setItemsPerPage(Number(e.target.value))} className="border rounded-lg px-2 py-1 text-xs">
                        <option value={3}>3</option>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                    </select>
                </div>

                <div className="flex items-center justify-center gap-2 flex-1 text-xs">
                    <button
                        onClick={() => setCurrentPage((currentPage <= 1) ? 1 : currentPage - 1)}
                        disabled={currentPage <= 1}
                        className={`px-2 py-1 rounded-lg border ${currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Prev
                    </button>

                    <span className="min-w-fit">{currentPage} of {totalPage || 1}</span>

                    <button
                        onClick={() => setCurrentPage((currentPage >= totalPage) ? totalPage : currentPage + 1)}
                        disabled={currentPage >= (totalPage || 1)}
                        className={`px-2 py-1 rounded-lg border ${currentPage >= (totalPage || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Next
                    </button>
                </div>

                <div className="text-xs text-slate-600 flex-1 text-center">
                    Total {totalItems || 0}
                </div>
            </div>

        </div>
    )
}

export default SocialProfiles